import React, { useRef } from "react";
// react router
import { Link } from 'react-router-dom';

import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import Slider from "react-slick";
import {
	TrendingSliderContainer,
	TrendingTitle,
	TrendingSlider,
	SLiderImageContainer,
	Title,
	SliderButtonContainer,
	IconContainer,
	LinkOuter,
} from "../../styles/TrendingNow";

// slider images
import candcholderImg from 'assets/images/whats-trending/candcholder.jpg'
import homeAccentsImg from 'assets/images/whats-trending/homeAccents.jpg'
import outdoorGardenImg from 'assets/images/whats-trending/outdoorGarden.jpg'
import potsPlantersImg from 'assets/images/whats-trending/potsPlanters.jpg'
import seasonalCatImg from 'assets/images/whats-trending/seasonalCat.jpg'
import vasesVesselsImg from 'assets/images/whats-trending/vasesVessels.jpg'
import weddingEventImg from 'assets/images/whats-trending/weddingEvent.jpg'

function TrendingNow(props) {
	let slider = useRef(null);

	return (
		<TrendingSliderContainer>
			<div className="container">
				<TrendingTitle>what’s trending now</TrendingTitle>
				<TrendingSlider>
					<div style={{ position: "relative" }}>
						<Slider
							ref={(c) => (slider = c)}
							adaptiveHeight={true}
							dots={false}
							arrows={false}
							autoplay={true}
							autoplaySpeed={3000}
							slidesToShow={4}
							slidesToScroll={1}
							draggable={false}
							responsive={[
								{
									breakpoint: 1200,
									settings: {
										slidesToShow: 4,
										slidesToScroll: 1,
										adaptiveHeight: true
									},
								},
								{
									breakpoint: 1008,
									settings: {
										slidesToShow: 3,
										slidesToScroll: 1,
										adaptiveHeight: true
									},
								},
								{
									breakpoint: 767,
									settings: {
										slidesToShow: 2,
										slidesToScroll: 1,
										adaptiveHeight: true
									},
								},
								{
									breakpoint: 575,
									settings: {
										slidesToShow: 2,
										slidesToScroll: 1,
										adaptiveHeight: true
									},
								},
							]}
						>
							{/* slider item */}
							<SLiderImageContainer>
								<LinkOuter>
									<Link to="/category/candles-candleholders?id=1" className="d-block text-decoration-none">
										<img
											src={candcholderImg}
											width="100%"
											alt="slide-img"
										/>
										<Title>CANDLES & CANDLEHOLDERS </Title>
									</Link>
								</LinkOuter>
							</SLiderImageContainer>

							{/* slider item */}
							<SLiderImageContainer>
								<LinkOuter>
									<Link to="/category/home-accents?id=7" className="d-block text-decoration-none">
										<img
											src={homeAccentsImg}
											width="100%"
											alt="slide-img"
										/>
										<Title>Home Accents </Title>
									</Link>
								</LinkOuter>
							</SLiderImageContainer>

							{/* slider item */}
							<SLiderImageContainer>
								<LinkOuter>
									<Link to="/category/outdoor-garden?id=16" className="d-block text-decoration-none">
										<img
											src={outdoorGardenImg}
											width="100%"
											alt="slide-img"
										/>
										<Title>OUTDOOR & GARDEN </Title>
									</Link>
								</LinkOuter>
							</SLiderImageContainer>

							{/* slider item */}
							<SLiderImageContainer>
								<LinkOuter>
									<Link to="/category/pots-planters?id=20" className="d-block text-decoration-none">
										<img
											src={potsPlantersImg}
											width="100%"
											alt="slide-img"
										/>
										<Title>Pots & Planters </Title>
									</Link>
								</LinkOuter>
							</SLiderImageContainer>

							{/* slider item */}
							<SLiderImageContainer>
								<LinkOuter>
									<Link to="/category/seasonal?id=42" className="d-block text-decoration-none">
										<img
											src={seasonalCatImg}
											width="100%"
											alt="slide-img"
										/>
										<Title>Seasonal </Title>
									</Link>
								</LinkOuter>
							</SLiderImageContainer>

							{/* slider item */}
							<SLiderImageContainer>
								<LinkOuter>
									<Link to="/category/vases-vessels?id=28" className="d-block text-decoration-none">
										<img
											src={vasesVesselsImg}
											width="100%"
											alt="slide-img"
										/>
										<Title>Vases & Vessels </Title>
									</Link>
								</LinkOuter>
							</SLiderImageContainer>

							{/* slider item */}
							<SLiderImageContainer>
								<LinkOuter>
									<Link to="/category/wedding-event?id=32" className="d-block text-decoration-none">
										<img
											src={weddingEventImg}
											width="100%"
											alt="slide-img"
										/>
										<Title>Wedding & Event </Title>
									</Link>
								</LinkOuter>
							</SLiderImageContainer>
						</Slider>

						{/* buttons */}
						<SliderButtonContainer>
							<IconContainer className="cursor-pointer">
								<MdChevronLeft
									className="left-btn"
									onClick={() => slider.slickPrev()}
								/>
							</IconContainer>
							<IconContainer className="cursor-pointer">
								<MdChevronRight
									className="right-btn"
									onClick={() => slider.slickNext()}
								/>
							</IconContainer>
						</SliderButtonContainer>
					</div>
				</TrendingSlider>
			</div>
		</TrendingSliderContainer>
	);
}

export default TrendingNow;
